import { ArrowUpRightIcon } from '@c/icons';
import type { CuratedListDocument } from '@models/curated_list';
import SafeImage from '@ui/SafeImage';
import Link from 'next/link';

const CuratedLists = ({ lists }: { lists: CuratedListDocument[] }) => {
  return (
    <div className="mt-16 flex flex-col gap-[3.2rem] lg:gap-[6.4rem]">
      <div className="mx-auto flex w-full gap-[1.6rem] overflow-x-scroll scrollbar-none">
        {lists?.map((curatedList) => (
          <CuratedListCard
            key={curatedList.id}
            text={curatedList.title}
            src={curatedList.card_src}
            href={`/shop/curated/${curatedList.slug}`}
          />
        ))}
      </div>
    </div>
  );
};

const CuratedListCard = ({
  text,
  src,
  href,
}: {
  text: string;
  src: string;
  href: string;
}) => (
  <Link
    href={href}
    className="group relative m-2 flex min-h-[44rem] min-w-[28.8rem] overflow-clip rounded-[2rem]"
  >
    <div className="absolute bottom-[2.4rem] left-[2.4rem] z-20 flex h-[6.2rem] w-[28.8rem] items-end pr-[2.4rem] text-[2.4rem] font-semibold text-white">
      {text}
    </div>

    <div className="absolute right-[2.4rem] top-[2.4rem] z-20 text-white">
      <ArrowUpRightIcon width={24} height={24} />
    </div>

    <div className="absolute inset-0 z-10 bg-curated-list-banner " />

    <SafeImage
      fill
      src={src}
      width={480}
      height={620}
      alt={`${text} curated list image`}
      classes="lg:transition-transform lg:duration-200 lg:delay-0 lg:ease-in-out lg:group-hover:scale-105 object-cover"
    />
  </Link>
);

export default CuratedLists;
